<template>
  <div id="cloudUserAddDialog">
    <el-tabs type="border-card">
      <el-tab-pane label="Obstoječi uporabniki">
        <div style="margin-top: 20px;" v-if="avaliableUsers.length > 0">
          <template v-for="user in avaliableUsers">
            <div>
              <el-radio
                :label="user.id"
                v-model="selectedExistingUser"
                border
                style="width: 100%"
              >{{ user.username }}
              </el-radio>
            </div>
          </template>
          <div style="text-align: right; margin-top:10px;">
            <el-button type="primary" :loading="connectUserProcessing" size="mini" @click="addExistingUser">
              {{ textPoveziSubmitButton }}
            </el-button>
          </div>
        </div>
        <div style="margin-top: 20px;" v-if="avaliableUsers.length === 0">
          <div style="text-align: center; margin: 50px 0px 20px 0px;">
            Ni uporabnikov, ki bi jih bilo mogoče povezati s projektom.
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Nov uporabnik">
        <el-form
          :model="user"
          status-icon
          :rules="formRules"
          ref="cloudUserAdd"
          label-width="150px"
          label-position="left"
          size="mini"
          :inline-message="true"
          style="margin-top: 20px;"
        >
          <el-form-item style="margin-bottom:5px;" prop="email">
            <template slot="label">
              <span style="font-weight: normal;">E-mail</span>
            </template>
            <el-input type="text" v-model="user.email" autocomplete="off">
            </el-input>
          </el-form-item>
          <el-form-item style="margin-bottom:5px;" prop="gsm">
            <template slot="label">
              <span style="font-weight: normal;">GSM</span>
            </template>
            <el-input type="text" v-model="user.gsm" autocomplete="off">
            </el-input>
          </el-form-item>
          <el-form-item prop="username" style="margin-bottom:5px;">
            <template slot="label">
              <span style="font-weight: normal;">Uporabniško ime</span>
            </template>
            <el-input type="text" v-model="user.username" class="cloudUsernameInputOverride">
              <template slot="prefix">cloud_</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password" style="margin-bottom:5px;">
            <template slot="label">
              <span style="font-weight: normal;">Geslo</span>
            </template>
            <el-input type="password" v-model="user.password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="passwordConfirm" style="margin-bottom:5px;">
            <template slot="label">
              <span style="font-weight: normal;">Potrditev gesla</span>
            </template>
            <el-input type="password" v-model="user.passwordConfirm" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item style="text-align: right;">
            <el-button type="primary" @click="submitForm" :loading="addingUserProcessing">
              {{ textSubmitButton }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>

import {Input, Form, FormItem, Button, Tabs, TabPane, RadioGroup, Radio} from 'element-ui'
import {CloudProject} from '../../../../../assets/js/T2Cloud/CloudProject'
import CloudUser from '../../../../../assets/js/T2Cloud/CloudUser'
import {CloudUserList} from '../../../../../assets/js/T2Cloud/CloudUserList'

export default {
  name: 'CloudUserAdd',
  components: {
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  props: {
    project: {
      type: CloudProject,
      required: true
    },
    ownUsers: {
      type: CloudUserList,
      required: true
    }
  },
  data () {
    return {
      user: new CloudUser(),
      formValid: true,
      addingUserProcessing: false,
      connectUserProcessing: false,
      formRules: {
        email: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'change'},
          {validator: this.formValidation.inputEmailValidation, trigger: 'change'}
        ],
        gsm: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'change'},
          {validator: this.formValidation.inputSloGsmValidation, trigger: 'change'}
        ],
        username: [{validator: this.formValidation.inputNotEmptyValidation, trigger: 'change'}],
        password: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'change'},
          {validator: this.passwordCharsRule, trigger: 'change'}
        ],
        passwordConfirm: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'change'},
          {validator: this.passwordCharsRule, trigger: 'change'},
          {validator: this.passwordsMatchRule, trigger: 'change'}
        ]
      },
      avaliableUsers: [],
      selectedExistingUser: null
    }
  },
  mounted () {
    this.ownUsers.list.forEach((user) => {
      if (user.siteId === this.project.siteId && this.project.users.getUserByUsername(user.username) === null) {
        this.avaliableUsers.push(user)
      }
    })
  },
  methods: {
    submitForm () {
      this.$refs['cloudUserAdd'].validate(async (valid) => {
        if (valid) {
          try {
            this.addingUserProcessing = true
            await this.user.addNew(this.project.idTerminationPoint)
            this.$emit('userAdded', {user: this.user, idTerminationPoint: this.project.idTerminationPoint})
            this.addingUserProcessing = false
          } catch (e) {
            this.ShowErrorMessage({message: e.message})
            this.addingUserProcessing = false
          }
        }
      })
    },
    passwordsMatchRule (rule, value, callback) {
      if (value !== this.user.password) {
        callback(new Error('Polje se mora ujemati z Novim geslom'))
      } else {
        callback()
      }
    },
    passwordCharsRule (rule, value, callback) {
      let re = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!,$.?\\/{}*+\\-<>@#"%&()=\'_\\[\\]÷\\\\|;:€łŁ~¸§×¤ß°¨])[\\w!,$.?\\/{}*+\\-<>@#"%&()=\'_\\[\\]÷\\\\|;:€łŁ~¸§×¤ß°¨]{8,50}$')
      if (!re.test(value)) {
        callback(new Error('Min 8 znakov. Vsaj 1 znak, številko, veliko in malo črko!'))
      } else {
        callback()
      }
    },
    async addExistingUser () {
      if (this.selectedExistingUser !== null) {
        let user = this.ownUsers.getUserById(this.selectedExistingUser)
        if (user !== null) {
          try {
            this.connectUserProcessing = true
            await this.project.connectUserWithProject(user)
            this.$emit('uporabnikPovezan')
            this.ShowSuccessMessage({message: `Uporabnik ${user.username} uspešno povezan s projektom`})
            this.connectUserProcessing = false
          } catch (e) {
            this.ShowErrorMessage({message: e.message})
            this.connectUserProcessing = false
          }
        } else {
          this.ShowErrorMessage({message: 'Ne najdem izbranega uporabnika'})
        }
      } else {
        this.ShowErrorMessage({message: 'Prosimo izberite uporabnika'})
      }
    }
  },
  computed: {
    textSubmitButton () {
      return this.addingUserProcessing ? 'Dodajam uporabnika... (lahko traja nekaj minut)' : 'Dodaj uporabnika'
    },
    textPoveziSubmitButton () {
      return this.connectUserProcessing ? 'Povezujem uporabnika... (lahko traja nekaj minut)' : 'Poveži uporabnika'
    }
  }
}

</script>

<style>
#cloudUserAddDialog .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #EF7D00;
  border-color: #EF7D00;
}

.cloudUsernameInputOverride input {
  padding-left: 43px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/T2Cloud/CloudUserAdd.vue